import { render, staticRenderFns } from "./FAQSection.vue?vue&type=template&id=468daed7&"
import script from "./FAQSection.vue?vue&type=script&lang=js&"
export * from "./FAQSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports